// extracted by mini-css-extract-plugin
export default {"flower":"W78rchmm","asterisk":"ppm8pPji","folder":"WU987fGu","grain":"BGSDshOm"};